"use client";

import { TimeFrame } from "charts/src/types/chart";
import { useSearchParams } from "next/navigation";

import { ChartGridLayout } from "@/features/analysis/components/key-metrices-charts/components/ChartGridLayout";
import ChartTimeFrameButtonGroup from "@/features/analysis/components/key-metrices-charts/components/ChartTimeFrameButtonGroup";
import { useUpdateQuery } from "@/hooks/use-update-query";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

const DEFAULT_TIME_FRAME = "Q";

export const ChartView = ({ lang, symbol }: { lang: Lang; symbol: string }) => {
  const { t } = getTranslations(lang);
  const { updateQuery } = useUpdateQuery();
  const timeFrame =
    (useSearchParams().get("timeFrame") as TimeFrame) ?? DEFAULT_TIME_FRAME;

  return (
    <>
      <ChartTimeFrameButtonGroup
        lang={lang}
        type="financialReport"
        onButtonClick={(value: string) => {
          updateQuery({ name: "timeFrame", value: value as TimeFrame });
        }}
        activeId={timeFrame}
      />
      <div className="min-h-[700px] md:mt-[-20px] lg:mt-[-40px]">
        <ChartGridLayout
          title={t.analysis.financialReports.financial}
          symbol={symbol}
          lang={lang}
          timeframe={timeFrame}
          chartCategoryPath="financialReport.financial"
          emptyHandlingPolicy="show-empty-view"
        />
      </div>
      <div>
        <ChartGridLayout
          title={t.analysis.financialReports.valuation}
          symbol={symbol}
          lang={lang}
          timeframe={timeFrame}
          chartCategoryPath="financialReport.valuation"
        />
      </div>
      <div>
        <ChartGridLayout
          title={t.analysis.financialReports.growth}
          symbol={symbol}
          lang={lang}
          timeframe={timeFrame}
          chartCategoryPath="financialReport.growth"
        />
      </div>
      <div>
        <ChartGridLayout
          title={t.analysis.financialReports.profitability}
          symbol={symbol}
          lang={lang}
          timeframe={timeFrame}
          chartCategoryPath="financialReport.profitability"
        />
      </div>
    </>
  );
};

export default ChartView;
